export default {
  // Text Panel
  '文本': 'Text',
  '颜色': 'Color',
  '字体': 'Font',
  '大写': 'Uppercase',
  '字号': 'Font Size',
  '背景色': 'Background Color',
  '圆角': 'Border Radius',
  '内边距': 'Padding',
  '描边': 'Stroke',
  '对齐': 'Align',
  '底边距': 'Bottom Margin',
  '紧贴底边': 'Bottom Align',
  '垂直居中': 'Vertical Center',

  // Basic Panel
  '基础': 'Basic',
  '位置': 'Position',
  '尺寸': 'Size',
  '旋转': 'Rotation',
  '居中': 'Center',
  '原始尺寸': 'Original Size',
  '平铺': 'Tile',
  '拉伸': 'Stretch',
  '透明度': 'Opacity',
  '视频尺寸为{width}x{height}。': 'Video size is {width}x{height}.',
  '调整文本尺寸可能会改变文本展示效果，建议调整字体大小': 'Adjusting text size may change the text display effect, it is recommended to adjust the font size',

  // Library
  '视频': 'Video',
  '音频': 'Audio',
  '图片': 'Image',
  '转场': 'Transition',
  '转场效果': 'Transition Effects',
  '点击应用': 'Click to Apply',
  '新建文本': 'New Text',
  '花字库': 'Font Library',
  '默认文本': 'Default Text',

  // Export
  '导出': 'Export',

  // Tools
  '撤销': 'Undo',
  '重做': 'Redo',

  // Tooltips
  '清除选中': 'Clear Selection',
  '删除当前选中': 'Delete Selected',
  '分割当前选中': 'Split Selected',
  '分割当前选中，只保留左侧': 'Split Selected, Keep Left Only',
  '分割当前选中，只保留右侧': 'Split Selected, Keep Right Only',
  '水平翻转': 'Flip Horizontal',
  '将连续且相邻的素材拼接后下载': 'Concatenate and Download Adjacent Materials',

  // Library
  '当前': 'Current',
  '导入': 'Import',
  '全部': 'All',
  '删除': 'Delete',
  '拖拽视频到这里': 'Drag video here',
  '拖拽音频到这里': 'Drag audio here',
  '拖拽图片到这里': 'Drag image here',
  '或者点击上传': 'or click to upload',
  '暂无素材，请先导入素材': 'No materials, please import materials first',

  // Manager
  '选择一个视频，开始你的创作。': 'Select a video, begin your creation.',

  // Animation Panel
  '动画': 'Animation',
  '入场动画': 'Enter Animation',
  '出场动画': 'Exit Animation',
  '关键帧动画': 'Keyframe Animation',
  '选择动画效果': 'Select Animation Effect',
  '添加': 'Add',
  '确定删除此动画？': 'Are you sure to delete this animation?',
  '持续时间': 'Duration',
  '秒': 'sec',
  '起始时间': 'Start Time',
  '结束时间': 'End Time',
  '暂无动画，请添加动画效果': 'No animations, please add animation effects',

  // Animation Presets
  '淡入': 'Fade In',
  '从左滑入': 'Slide In Left',
  '从右滑入': 'Slide In Right',
  '从上滑入': 'Slide In Top',
  '从下滑入': 'Slide In Bottom',
  '放大进入': 'Zoom In',
  '旋转进入': 'Rotate In',
  '淡出': 'Fade Out',
  '向左滑出': 'Slide Out Left',
  '向右滑出': 'Slide Out Right',
  '向上滑出': 'Slide Out Top',
  '向下滑出': 'Slide Out Bottom',
  '缩小退出': 'Zoom Out',
  '旋转退出': 'Rotate Out',
  '脉冲': 'Pulse',
  '抖动': 'Shake',
  '弹跳': 'Bounce',
  '摆动': 'Swing',
  '闪烁': 'Flash',
  '自定义': 'Custom',
  '起始状态': 'Start State',
  '结束状态': 'End State',
  '位置 X': 'Position X',
  '位置 Y': 'Position Y',
  '缩放': 'Scale',
  '旋转角度': 'Rotation',
  '不透明度': 'Opacity',

  // Filter Panel
  '可用滤镜': 'Available Filters',
  '滤镜参数': 'Filter Parameters',
  '选择滤镜': 'Select Filter',
  '请选择要编辑的滤镜': 'Please select a filter to edit',
  '强度': 'Intensity',
  '请选择一个滤镜以调节参数': 'Please select a filter to adjust parameters',
  '灰度': 'Grayscale',
  '模糊': 'Blur',
  '亮度': 'Brightness',
  '对比度': 'Contrast',
  '饱和度': 'Saturate',

  '无': 'None',
  '入场': 'Entry',
  '出场': 'Exit',
  '动效': 'Animation',
  '结束位置': 'End Position',
  '使用当前时间轴上的当前时间点': 'Use current time point on timeline',
  '开始位置': 'Start Position',
  '当前有动画，调整可能不能直接看到效果，请播放片段查看': 'Current animation may not show direct effect, please play the segment to check',
  '滤镜': 'Filter',
  '恢复正在编辑的数据': 'Restore editing data',
  '仅支持视频和图片': 'Only support video and image',
  '删除转场': 'Delete Transition',
  '已经存在视频转场，请先删除': 'Video transition already exists, please delete first',
  '当前片段是轨道最后一个片段，不能应用转场效果': 'Current segment is the last one in the track, cannot apply transition effect',
  '暂无转场效果': 'No transition effects available',
  '片段不存在': 'Segment does not exist',
  '请先选择一个片段': 'Please select a segment first',
  '轨道不存在': 'Track does not exist',
  '默认': 'Default',

  // 转场效果
  '淡入淡出': 'Fade',
  '滑动': 'Slide',
  '百叶窗': 'Blinds',
  '溶解': 'Dissolve',

  // Video/Audio Panel
  '音量': 'Volume',
  '请先选择视频片段': 'Please select a video segment first',
  '请先选择音频片段': 'Please select an audio segment first',
  '重置': 'Reset',

  // Advanced Export
  '高级导出': 'Advanced Export',
  '取消': 'Cancel',
  '正在导出...': 'Exporting...',
  '导出完成！': 'Export completed!',
  '导出失败：': 'Export failed: ',
  '导出类型': 'Export Type',
  '输出格式': 'Output Format',
  '分辨率': 'Resolution',
  '帧率': 'FPS',
  '视频比特率': 'Video Bitrate',
  '编码格式': 'Codec',
  '包含音频': 'Include Audio',
  '关闭时将导出无声音的视频': 'Will export video without sound when disabled',
  '音频比特率': 'Audio Bitrate',
  '比特率': 'Bitrate',
  '采样率': 'Sample Rate',
  '导出中...': 'Exporting...',
  '开始导出': 'Start Export',
};
